// This library is the Developer Interface for adding and updating tissue labels, body parts, and model types.
// The goal of this lib is to allow a developer to add or update a ModelType, then have the TS compiler guide them through the entire project,
// catching every change necessary for the new ModelType to work across the Innersight platform.
// It should contain only the distilled, essential semantic information needed to add another tissue type or operation type to the Innersight platform.
// Only static definitions of schemas relating to different model, operation and tissue types belong here.
// This file should have no internal or external dependencies, and should know nothing about e.g. external libraries, rendering techniques etc.

export * from './lib/body-parts'
export * from './lib/buttons'
export * from './lib/materials'
export * from './lib/meshing-params'
export * from './lib/postprocessing-params'
export * from './lib/model-configs'
export * from './lib/tissue-labels'
export * from './lib/hotkeys'
export * from './lib/volumetry'